import { render, staticRenderFns } from "./CategoryPage.vue?vue&type=template&id=09a2036e"
import script from "./CategoryPage.vue?vue&type=script&lang=js"
export * from "./CategoryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CategoryBreadcrumbs: require('/app/components/category/breadcrumbs.vue').default,Title: require('/app/components/title.vue').default,HeaterCalculatorCta: require('/app/components/heaterCalculatorCta.vue').default,CategoryTabs: require('/app/components/category/tabs.vue').default,BlockCategories: require('/app/components/block/categories.vue').default,BlockProducts: require('/app/components/block/products.vue').default})
